import React from "react";
import Signature from "../components/Signature";
import Layout from "./Layout.js";

export default function SignView() {
  return (
    <Layout title="Afmelden Order">
      {" "}
      <Signature />
    </Layout>
    // <div className="pageWrapper">
    //   <Header title="Afmelden Order" />
    //   <div className="contentWrapper fadeInDelayed">
    //     <Signature />
    //   </div>
    //   <BottomNavBar />
    // </div>
  );
}
